import { render, staticRenderFns } from "./MultiDialogSelector.vue?vue&type=template&id=3c49f67a&scoped=true&"
import script from "./MultiDialogSelector.vue?vue&type=script&lang=ts&"
export * from "./MultiDialogSelector.vue?vue&type=script&lang=ts&"
import style0 from "./MultiDialogSelector.vue?vue&type=style&index=0&id=3c49f67a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c49f67a",
  null
  
)

export default component.exports